import styled from '@emotion/styled';
import { WhiteLabelMobileButton, Magnetic } from '@mitchell/react.component.ux';
export const StyledProgressBarContainer = styled('div') `
	text-align: center;
	padding-top: ${Magnetic.spacer40};
`;
export const StyledRetryButton = styled(WhiteLabelMobileButton) `
	margin-top: ${Magnetic.spacer96};
`;
export const StyledCancelUploadDiv = styled('div') `
	color: ${(props) => props.color || Magnetic.colorBrand40};
	text-decoration: underline;
	margin-top: ${Magnetic.spacer06};
	cursor: ${Magnetic.actionableCursor};
`;
export const StyledProgressBar = styled('div') `
	margin: ${Magnetic.spacer06} 0;
`;
export const StyledUploadFailedIcon = styled('span') `
	color: ${Magnetic.annotationAlertColor};
	font-size: ${Magnetic.fontSize14};
	padding-right: ${Magnetic.spacer04};
`;
//# sourceMappingURL=PhotoCaptureFileUploadProgressBar.style.js.map